import { NgModule } from '@angular/core';
import { BnpOidcHelperTokenComponent } from './bnp-oidc-helper-token.component';

@NgModule({
  declarations: [BnpOidcHelperTokenComponent],
  imports: [
  ],
  exports: [BnpOidcHelperTokenComponent]
})
export class BnpOidcHelperTokenModule { }
